import { computed, toValue, toRefs } from "vue";
import { useMagicEmitter } from "../../../MagicEmitter/index.mjs";
import { useDrawerState } from "./private/useDrawerState.mjs";
export function useMagicDrawer(id) {
  const { initializeState } = useDrawerState(toValue(id));
  const state = initializeState();
  const { progress, active } = toRefs(state);
  const isActive = computed(() => active.value);
  function open() {
    active.value = true;
  }
  function close() {
    active.value = false;
  }
  function snapTo(snapPoint, duration) {
    useMagicEmitter().emit("snapTo", {
      id: toValue(id),
      snapPoint,
      duration
    });
  }
  return {
    isActive,
    progress,
    open,
    close,
    snapTo
  };
}
